import { SET_NETWORKSTATE } from "./network.types";

export const setNetworkOnline = (connected) => {
    return {
        type: SET_NETWORKSTATE,
        payload: connected
    }
}